import { QIResultStatus } from 'common/types';

export enum SubmitStatus {
  PROCESSING = 'PROCESSING',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}
// 在质检组件中，与显示的页面相关
export enum CurrentPage {
  Upload = 0, // 文件上传
  // Preview, // 文件预览
  Submit, // 版本提交
}

// 前端维护的状态，质检流程的阶段
export enum QIStep {
  Prepare = '选择文件', // 准备阶段，用户选择文件
  Uploading = '文件上传中', //上传文件中
  Waiting = '等待开始', // 排队中
  // Checking = '文件质检中', // 质检中
  // CheckFinish = '待确认提交', // 质检完成
  Submitting = '提交中', // 提交中
  SubmitSuccess = '提交成功', // 提交成功
  SubmitError = '提交失败', // 提交失败
  // ReplacingFiles = '替换异常文件中', // 替换中
  UploadError = '上传失败', // 上传失败
}
//映射taskStatus的result字段到currentPage
export const mapStatusToCurrentStep = (result: QIResultStatus) => {
  return {
    [QIResultStatus.WAITING]: QIStep.Waiting,
    [QIResultStatus.PROCESSING]: QIStep.Checking,
    [QIResultStatus.FINISH]: QIStep.CheckFinish,
    [QIResultStatus.UPLOAD_PROCESSING]: QIStep.Submitting,
    [QIResultStatus.UPLOAD_SUCCESS]: QIStep.SubmitSuccess,
    [QIResultStatus.UPLOAD_ERROR]: QIStep.SubmitError,
    [QIResultStatus.UPLOADING]: QIStep.Uploading,
    [QIResultStatus.WAITING_UPLOADING]: QIStep.Prepare,
    [QIResultStatus.REPLACING_FILES]: QIStep.ReplacingFiles,
    [QIResultStatus.UPLOADING_ERROR]: QIStep.UploadError,
  }[result];
};

export const mapStatusToCurrentPage = (result: QIResultStatus) => {
  return {
    [QIResultStatus.WAITING]: CurrentPage.Upload,
    [QIResultStatus.PROCESSING]: CurrentPage.Upload,
    [QIResultStatus.FINISH]: CurrentPage.Upload,
    [QIResultStatus.UPLOAD_PROCESSING]: CurrentPage.Submit,
    [QIResultStatus.UPLOAD_SUCCESS]: CurrentPage.Submit,
    [QIResultStatus.UPLOAD_ERROR]: CurrentPage.Submit,
    [QIResultStatus.UPLOADING]: CurrentPage.Upload,
    [QIResultStatus.WAITING_UPLOADING]: CurrentPage.Upload,
    [QIResultStatus.REPLACING_FILES]: CurrentPage.Upload,
    [QIResultStatus.UPLOADING_ERROR]: CurrentPage.Upload,
  }[result];
};
